import Vue from 'vue'
import Router from 'vue-router'
import { getLocale } from '@didi/gettext'
import clientC from './c/index'
import clientD from './d/index'
import sharebox from './sharebox/index'
import unsubscribe from './unsubscribe/index'
import bannerCPopup from '@/page/banner/route/index'
import landingpage from '@/page/landingpage/route'
import newCouponsCenter from '@/page/newCouponsCenter/route'
// import { routerRedirectCatch } from '@/common/js/routerRedirectCatch'
Vue.use(Router)
// 解决 router A重定向到B，B直接重定向到C时报错的问题或者降级vueRouter版本到3.0.7
// routerRedirectCatch(Router)

const notFount = {
  path: '*',
  name: 'notFound',
  component: () => import('@/page/index')
}

let locale = getLocale()
const router = new Router({
  mode: 'history',
  base: locale || '/',
  routes: [
    notFount,
    clientC,
    clientD,
    bannerCPopup,
    unsubscribe,
    landingpage,
    sharebox,
    newCouponsCenter
  ]
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})
export default router
